import SingleButtonSelection from "common/bit/SingleButtonSelection"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import styled from "styled-components"
import { TypographyRtl } from "theme/shared"

const StyledWrapper = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 540px;
    margin: 0 auto;
  }
`
const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  button {
    width: auto;
  }
`
const StyledButton = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`
const StyleChipButton = styled.div<{ $activeButton: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 3px;
  background-color: ${(p) =>
    p.$activeButton ? p.theme.colors.black : p.theme.colors.white};
  &.icon {
    background-color: ${(p) =>
      p.$activeButton ? p.theme.colors.white : p.theme.colors.disable};
    stroke: ${(p) => p.theme.colors.black};
    fill: ${(p) => p.theme.colors.black};
  }
  p {
    color: ${(p) =>
      p.$activeButton ? p.theme.colors.white : p.theme.colors.black};
  }
`

type ToggleButtonsProps = {
  activeButton: number
  setActiveButton: Dispatch<SetStateAction<number>>
  optionsList: string[]
  icons?: React.FC<any>[]
  toggleId: string
  className?: string
  isSelectAll?: boolean
}

const MultibleChipsRow = ({
  activeButton,
  setActiveButton,
  optionsList,
  toggleId,
  className,
  icons,
  isSelectAll = false,
}: ToggleButtonsProps) => {
  const [selectAll, setSelectAll] = useState(false)

  useEffect(() => {
    setSelectAll(isSelectAll)
  }, [isSelectAll])

  return (
    <StyledWrapper className={className}>
      <StyledSingleButtonSelection
        id={toggleId}
        itemsPerRow="auto"
        items={optionsList.map((item, index) => ({
          value: index,
          name: item,
          icon: icons && item === "icon" ? icons[index] : undefined,
        }))}
        selectedValue={activeButton}
        onSelect={(code) => {
          setActiveButton(Number(code))
        }}
        customButton={(radioId, isSelected, item) => {
          const IconComponent = item.icon
          return (
            <StyledButton htmlFor={radioId} $activeButton={isSelected}>
              <StyleChipButton
                $activeButton={selectAll ? true : isSelected}
                className={`${item.icon ? "icon" : ""}`}
              >
                {item.icon ? (
                  <IconComponent /> // use a react component instead of a string
                ) : (
                  <TypographyRtl variant="body2">{item.name}</TypographyRtl> // default string in case there's no icon (the default is string)
                )}
              </StyleChipButton>
            </StyledButton>
          )
        }}
      />
    </StyledWrapper>
  )
}

export default MultibleChipsRow
